/* istanbul ignore file */
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { BudgetLink, useBudgetService } from '../index';
import { EMPTY_VALUE_INDICATOR, useAsyncValue } from 'framework/utils';
import { InputLoader } from 'framework/ui/mui-builder';

const BudgetLinkWithNameLoadingField = ({ source, value, ...props }: FieldProps) => {
  const { getById } = useBudgetService();
  const { getValue: getId } = useFieldHelper({ source });
  const budgetId = value || getId();
  const budgetData = useAsyncValue(() => (budgetId ? getById(budgetId) : Promise.resolve({})), [budgetId]);
  const budgetName = budgetData?.name;
  const fieldValue = budgetName === null ? <InputLoader /> : <BudgetLink name={budgetName} id={budgetId} {...props} />;
  const displayedValue = budgetId ? fieldValue : EMPTY_VALUE_INDICATOR;

  return <TextField value={displayedValue} {...props} />;
};

export default BudgetLinkWithNameLoadingField;
